// test666
(666 && 0);
